import { NavLink, useLocation } from "react-router-dom";

import { MdDashboard, MdCampaign, MdAssessment, MdPerson, MdPayment, MdBusiness, MdPeople, MdWebhook } from "react-icons/md";

import { LogoContainer, Menu, SidebarContainer } from "./SidebarStyle";

const Sidebar = ({ forwardRef }) => {
  const location = useLocation();
  const currentRoute = location.pathname;
  return (
    <SidebarContainer ref={forwardRef}>
      <LogoContainer>
          {/* <img src={Logo} alt="digiclick logo" /> */}
          <h1>Meta<span>Click</span></h1>
      </LogoContainer>

      <Menu>
        <ul>
          <li>
            <NavLink to="/">
            <MdDashboard className="icon" />
            Dashboard
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/campaigns"
              className={
                currentRoute === "/create-campaign" ||
                currentRoute.startsWith("/edit-campaign/") ||
                currentRoute.startsWith("/view-campaign/")||
                currentRoute.startsWith("/campaign-link/")
                  ? "active"
                  : ""
              }
            >
              <MdCampaign className="icon" />
              Campaigns
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/advertisers"
              className={
                currentRoute === "/create-advertiser" ||
                currentRoute.startsWith("/edit-advertiser/") ||
                currentRoute.startsWith("/view-advertiser/")
                  ? "active"
                  : ""
              }
            >
              <MdBusiness className="icon" />
              Advertisers
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/publishers"
              className={
                currentRoute === "/create-publisher" ||
                currentRoute.startsWith("/edit-publisher/") ||
                currentRoute.startsWith("/view-publisher/") ||
                currentRoute.startsWith("/publisher-link")
                  ? "active"
                  : ""
              }
            >
              <MdPeople className="icon" />
              Publishers
            </NavLink>
          </li>
          <li>
            <NavLink to="/billing">
              <MdPayment className="icon" />
              Billing and payments
            </NavLink>
          </li>
          <li>
            <NavLink to="/postback">
              <MdWebhook className="icon" />
              Postback management
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/reports"
              className={
                currentRoute.startsWith("/view-report/") ||
                currentRoute.startsWith("/publisher-campaigns/") ||
                currentRoute.startsWith("/publisher-details/") ||
                currentRoute.startsWith("/campaign-details/") ||
                currentRoute.startsWith("/campaign-publishers/")  ? "active" : ""
              }
            >
              <MdAssessment className="icon" />
              Report and analytics
            </NavLink>
          </li>
          <li>
            <NavLink to="/profile" className={
                currentRoute === "/create-member" ||
                currentRoute.startsWith("/edit-member/")
                  ? "active"
                  : ""
              }>
            
            <MdPerson className="icon" />
              Profile
            </NavLink>
          </li>
        </ul>
      </Menu>
    </SidebarContainer>
  );
};

export default Sidebar;
